import "../../registry.js";
export const modificationKinds = [
    ["Add", 1],
    ["Subtract", 2],
    ["Unknown", 3],
];
//# sourceMappingURL=globalAccountant.js.map